const assetPath = process.env.REACT_APP_AZUR_ASSET_PATH;
const loader1 =assetPath+ "/main/assets/img/icons/pre-loader-01.svg";
const loader2 =assetPath+ "/main/assets/img/icons/pre-loader-02.svg";
const loader3 =assetPath+ "/main/assets/img/icons/pre-loader-03.svg";
const loader4 =assetPath+ "/main/assets/img/icons/pre-loader-04.svg";
const loader5 =assetPath+ "/main/assets/img/icons/pre-loader-05.svg";
export default function Loader() {
    return (
        <div className="page-loader-cont">
        <div className="re-page-loader" id="pageLoader">
           	<div className="re-page-loader-inner">
               	<div className="fadein-element">
                   	<img src={loader1} alt="Royal Enfield"/>
                   	<img src={loader2} alt="Royal Enfield"/>
                   	<img src={loader3} alt="Royal Enfield"/>
                   	<img src={loader4} alt="Royal Enfield"/>
                   	<img src={loader5} alt="Royal Enfield"/>
               	</div>
               	<div className="loading-ellipsis">
                   	<div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
        	</div>
       	</div>
    </div>
    );
}